import { render, staticRenderFns } from "./ListMenuItemWithoutProfile.vue?vue&type=template&id=5d355156&scoped=true"
import script from "./ListMenuItemWithoutProfile.vue?vue&type=script&lang=js"
export * from "./ListMenuItemWithoutProfile.vue?vue&type=script&lang=js"
import style0 from "./ListMenuItemWithoutProfile.vue?vue&type=style&index=0&id=5d355156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d355156",
  null
  
)

export default component.exports